import styled from "styled-components";
import colors from "@styling/colors";
import { spacing } from "@styling/sizing";

const ToggleSwitch = styled.label<{ $disabled?: boolean }>`
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
`;

const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    background-color: ${colors.primary};
  }

  &:checked + span:before {
    transform: translateX(20px);
  }

  &:disabled + span {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;

const ToggleSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors.border};
  transition: 0.3s;
  border-radius: 24px;

  &:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
  }
`;

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.x2}px;
`;

interface ToggleProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  onBlur?: () => void;
  label?: string;
  disabled?: boolean;
  readOnly?: boolean;
}

export const Toggle = ({ checked, onChange, onBlur, label, disabled, readOnly }: ToggleProps) => {
  const isDisabled = Boolean(disabled || readOnly);
  return (
    <ToggleContainer>
      <ToggleSwitch $disabled={isDisabled}>
        <ToggleInput
          type="checkbox"
          checked={checked}
          onChange={onChange ? (e) => onChange(e.target.checked) : undefined}
          onBlur={onBlur}
          disabled={isDisabled}
          readOnly={readOnly}
        />
        <ToggleSlider />
      </ToggleSwitch>
      {label && <span>{label}</span>}
    </ToggleContainer>
  );
};
